import React from 'react';
import './chapters.scss';
import Hyperlink from '../Hyperlink/Hyperlink';

function Chapter4() {
  const hyperlinkData = {
    origin: '',
    href: 'https://988lifeline.org/',
    a: 'https://988lifeline.org'
  };
  return (
    <div className="chapters__chapter">
      <h3>Recognizing Treatment-Resistant Forms of Clinical Depression</h3>
      <p className="chapters__chapter__paragraph">
        With the help of the “dream team,” Austin was diagnosed with clinical depression; Allison
        recalls that after Austin’s diagnosis, they had a lot of hope. “We hoped that after he got
        on an oral antidepressant, it would work quickly, and he’d get back to normal.” At first,
        things went just as they expected: Austin was able to resume attending class and graduated
        high school.
      </p>
      <p className="chapters__chapter__paragraph">
        For some people living with clinical depression, starting treatment can be a major turning
        point — the moment where things change for the better. But for those with
        challenging-to-treat depression, these signs of hope can be fleeting.
      </p>
      <p className="chapters__chapter__paragraph">
        “For Austin,” Allison recalls, “It was just a temporary fix. We’d try a different
        medication, and he’d call me and tell me the symptoms were coming back.” Allison spoke to
        Austin’s psychiatrist about this cycle. “That was the first time,” she says, “I heard the
        term ‘treatment-resistant depression.’”
      </p>
      <p className="chapters__chapter__paragraph">
        Ultimately, Austin dropped out of college during his first semester. “He was in a really
        dark place,” Allison recalls. “I will never forget when his therapist called me, and said
        she was really worried about him, and not soon after that, he attempted suicide. I still get
        emotional thinking about it; no mother wants to get that phone call.”
      </p>
      <div className="chapters__chapter__infobox chapters__chapter__infobox--border">
        If you or someone you know is struggling emotionally or has concerns about their mental
        health, there are ways to get help. Call the 988 Suicide & Crisis Lifeline at 988 or visit{' '}
        <Hyperlink hyperlinkData={hyperlinkData} />.
      </div>
    </div>
  );
}

export default Chapter4;
